import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";
import { Star } from "lucide-react";
import { Toggle } from "@/pages/admin/AdminProducts";

export default function AdminPackages() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/admin/packages").then((r) => {
      setPackages(r.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => { load(); }, [load]);

  const update = async (slug, patch) => {
    try {
      await api.patch(`/admin/packages/${slug}`, patch);
      setPackages((ps) => ps.map((p) => (p.slug === slug ? { ...p, ...patch } : p)));
    } catch (e) {
      alert("Error al actualizar");
    }
  };

  return (
    <div className="p-8 md:p-12" data-testid="admin-packages">
      <div className="mb-8">
        <div className="text-xs tracking-[0.35em] uppercase text-arre-red mb-2">⟡ Admin</div>
        <h1 className="font-display text-4xl md:text-5xl tracking-wider uppercase text-white leading-none">Paquetes</h1>
      </div>

      <div className="bg-arre-surface border border-arre-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-arre-border text-[10px] tracking-[0.2em] uppercase text-white/50">
              <th className="text-left p-4">Paquete</th>
              <th className="text-left p-4">Sirve</th>
              <th className="text-left p-4">Items</th>
              <th className="text-left p-4">Precio</th>
              <th className="text-left p-4">Destacado</th>
              <th className="text-left p-4">Activo</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="6" className="p-8 text-center text-white/50">Cargando...</td></tr>}
            {packages.map((p) => (
              <tr key={p.slug} className="border-b border-arre-border/50" data-testid={`admin-package-${p.slug}`}>
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <img src={p.image} alt={p.name} className="w-12 h-12 object-cover border border-arre-border" />
                    <div>
                      <div className="font-display text-white">{p.name}</div>
                      <div className="text-xs text-white/40 italic">{p.tagline}</div>
                    </div>
                  </div>
                </td>
                <td className="p-4 text-white/70">{p.serves}</td>
                <td className="p-4 text-white/70">{p.items?.length || 0}</td>
                <td className="p-4">
                  <div className="flex items-center gap-1 text-white font-display">
                    <span className="text-white/50 text-sm">$</span>
                    <input
                      type="number"
                      min="0"
                      step="1"
                      defaultValue={p.price}
                      onBlur={(e) => {
                        const nv = parseFloat(e.target.value);
                        if (!isNaN(nv) && nv > 0 && nv !== p.price) update(p.slug, { price: nv });
                      }}
                      className="w-28 bg-arre-black border border-arre-border px-2 py-1 text-white focus:outline-none focus:border-arre-red"
                      data-testid={`pkg-price-${p.slug}`}
                    />
                  </div>
                </td>
                <td className="p-4">
                  <button
                    onClick={() => update(p.slug, { featured: !p.featured })}
                    className={`${p.featured ? "text-arre-red" : "text-white/30"} hover:scale-110 transition`}
                  >
                    <Star className="w-5 h-5" fill={p.featured ? "currentColor" : "none"} />
                  </button>
                </td>
                <td className="p-4">
                  <Toggle active={p.active !== false} onChange={(v) => update(p.slug, { active: v })} testid={`pkg-active-${p.slug}`} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
